import React from 'react'
// @src imports
import { Dialog } from 'src/chrome'
import { Maybe } from 'src/graphql'

import AddressForm, { FormContact, NonNullableAttributes } from './AddressForm'
import styles from './addressForm.module.scss'
import { DialogContent } from '@material-ui/core'

interface Props {
  isModal?: boolean
  isSaving?: boolean
  contact?: FormContact
  shouldShowAddressOnly?: boolean
  checkboxText?: string
  secondaryCheckboxText?: string
  disableCountryReason?: string
  isSecondaryCheckboxChecked?: boolean
  confirmButtonText?: string
  errorMessages?: Maybe<string>[]
  close: () => void
  onSubmit: (
    contact: NonNullableAttributes<FormContact>,
    isCheckboxChecked: boolean,
    isSecondaryCheckboxChecked: boolean,
  ) => void
}

const AddressFormModal: React.FC<Props> = props => {
  const {
    close,
    isModal,
    isSaving,
    contact,
    onSubmit,
    shouldShowAddressOnly,
    checkboxText,
    disableCountryReason,
    secondaryCheckboxText,
    isSecondaryCheckboxChecked,
    errorMessages,
    confirmButtonText,
  } = props
  return (
    <Dialog
      disableBackdropClick={isModal ?? false}
      open={true}
      onClose={close}
      scroll={'paper'}
    >
      <DialogContent className={styles.addressModal}>
        <AddressForm
          isTitleVisible={!shouldShowAddressOnly}
          contact={contact}
          close={close}
          onSubmit={onSubmit}
          isSaving={isSaving}
          shouldShowDates={!shouldShowAddressOnly}
          checkboxText={checkboxText}
          secondaryCheckboxText={secondaryCheckboxText}
          isSecondaryCheckboxChecked={isSecondaryCheckboxChecked}
          disableCountryReason={disableCountryReason}
          errorMessages={errorMessages}
          confirmButtonText={confirmButtonText}
        />
      </DialogContent>
    </Dialog>
  )
}

export default AddressFormModal
